<mat-dialog-content>
  <div style="display: flex;">
    <div style="width: 100%">
      <h1 style="font-size: 1.5rem">Create Cohort</h1>
    </div>

    <lib-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </lib-icon-button>
  </div>
    
  <lib-content-loader *ngIf="loading"></lib-content-loader>
    <div *ngIf="!loading" [formGroup]="form">
      <div >
        <mat-form-field class="full-width" actions appearance="outline">
          <mat-label>Cohort Name</mat-label>
          <input matInput type="text" formControlName="name">
        </mat-form-field>
      </div>
    
    
    </div>
</mat-dialog-content>
<mat-dialog-actions style="gap: 0.8rem; padding: 0 2rem 1rem" align="end">
  <lib-button color="primary" mat-button mat-dialog-close>Cancel</lib-button>
 <lib-button color="primary" mat-button (click)="create()">Create</lib-button>
</mat-dialog-actions>